// React and related imports
import React from 'react';

// i18 hooks
import { useTranslation } from 'react-i18next';

// Custom Components
import { TableHead } from '../Table/Table';

interface SessionTableHeadProps {
  sortingHandler?: (fieldId: string) => void;
}

export const SessionTableHead: React.FC<SessionTableHeadProps> = ({
  sortingHandler,
}) => {
  const { t } = useTranslation();

  const columnHeadLabels = [
    { id: 'title', label: t('sessions.title'), sortable: true },
    { id: 'description', label: t('sessions.description') },
    { id: 'url', label: t('sessions.url') },
    { id: 'status', label: t('sessions.status') },
    { id: 'assignments', label: t('sessions.assignments') },
    { id: 'completed', label: t('sessions.completed') },
    { id: 'createdAt', label: t('sessions.createdAt'), sortable: true },
    { id: 'actions', label: t('sessions.actions') },
  ];

  return (
    <TableHead
      columns={columnHeadLabels}
      onClick={sortingHandler}
      withSortingIcon
    />
  );
};
